export default "__VITE_ASSET__Dmh0C5dS__"